import router from './router';
import NProgress from 'nprogress';
import { Message } from 'element-ui';
import 'nprogress/nprogress.css';
import { userInfo } from '@/stores/userInfo';
import { appInfo } from '@/stores/appInfo';
import { usePermissionStore } from '@/stores/routers';
import { pinia } from '@/main';
import Auth from '@/utils/auth';
import VueRouter from 'vue-router';
import * as hinaApi from '@/utils/hina';

NProgress.configure({ showSpinner: false });

router.beforeEach(async (to, from, next) => {
  const userStore = userInfo(pinia);
  const appStores = appInfo(pinia);
  const permissionStore = usePermissionStore(pinia);
  const toHome = to.path.split('/')?.[1] ?? '';
  // 检测是否隐藏头尾部isHideHeaderFooter，如果为true，则不显示头尾部，将状态存在sessionStorage
  if (to.query?.isHideHeaderFooter) {
    sessionStorage.setItem('isHideHeaderFooter', 'true');
  } else {
    sessionStorage.removeItem('isHideHeaderFooter');
  }
  if (toHome === 'shopplat' || toHome === 'enterpriseadmin') {
    document.title = to.meta?.title
      ? to.meta.title + ' - ' + appStores.appSetting.appName
      : appStores.appSetting.appName;
  } else {
    document.title = to.meta?.title ? to.meta.title + ' - ' + appStores.seoShopName : appStores.seoShopName;
  }
  NProgress.start();
  if ((to.path == '/register' || to.path == '/login') && from.path != '/register' && from.path != '/login') {
    appStores.redirectUrl = appStores.isRedirectUrl ? from.fullPath : '';
    // 主动退出清空 redirctUrl ,防止不同角色登录跳转到404
    appStores.isRedirectUrl = true;
  }
  if (appStores.isPointHost && to.path == '/') {
    next({ path: '/point' });
  }

  if (Auth.getToken()) {
    if (!userStore.userId) {
      try {
        await userStore.GetInfo();
        // 设置登录埋点数据
        hinaApi.setUserInfo({
          user_name: userStore.userName,
          zdy_user_id: userStore.userId,
          phone: userStore.phonenumber,
          company_name: userStore.enterpriseName,
        });

        const accessRoutes = await permissionStore.GenerateRoutes();

        router.addRoutes(accessRoutes);
        next({ ...to, replace: true });
      } catch (err) {
        userStore.LogOut().then(() => {
          Message.error(err);
          next({ path: '/' });
        });
      }
    } else {
      next();
      NProgress.done();
    }
  } else {
    if (to.meta?.needLogin) {
      // 跳到登录页
      next('/login');
      appStores.redirectUrl = to.fullPath;
      NProgress.done();
    } else {
      next();
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  window.scrollTo(0, 0);
  NProgress.done();
});
